/**
 * Timezone configuration for the application
 * All times should be handled in Central Time (America/Chicago)
 */

export const BUSINESS_TIMEZONE = 'America/Chicago';
export const TIMEZONE_LABEL = 'CT';
export const TIMEZONE_FULL_LABEL = 'Central Time';
export const MINIMUM_BOOKING_LEAD_TIME_MINUTES = 30; // Clients need 30 min to book/prepare
